import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LOCAL_STORAGE_KEY } from 'constants/localStorage';
import ls from 'local-storage';
import { nanoid } from 'nanoid';

import CommonHelper from '../../helpers/CommonHelper';
import UserTemplate from '../templates/UserTemplate/UserTemplate';

export default function StripeStatusApp() {
  const navigate = useNavigate();
  const { status } = useParams();
  const isSuccess = status == 'success';

  useEffect(() => {
    if (isSuccess == true) {
      CommonHelper.yandexTrackEvent('payment');
      try {
        const visitor_id = ls.get('visitor_id');

        if (visitor_id) {
          fetch(`https://sancontr.com/conversion/f6bfb4a3ef2b36dc17473a85e583fd36ec2a9dff/?visitor_id=${visitor_id}&aid=288863&goal=deposit_suc`);
        }
      } catch (_exc) { }
    }
    setTimeout(() => {
      navigate('/');
      window.location.reload();
    }, 10 * 1000);
  }, [status]);

  useEffect(() => {
    if (isSuccess) {
      ls(LOCAL_STORAGE_KEY.PAYMENT_SUCCESS_ORDER_ID, nanoid());
    }
  }, []);

  return (
    <UserTemplate currentName={'stripe'}>
      {isSuccess && (
        <div className={'p-10 text-center text-xl text-white'}>
          Thanks for upgrading to Premium! Your payment was successful.
          <br />
          Please note that upgrading to Premium can take up to 5 minutes.
          <br />
          You will be redirected to the home page in 10 seconds.
        </div>
      )}

      {!isSuccess && (
        <div className={'text-center text-red-500'}>
          Your payment was not successful. Please try again.
          <br />
          You will be redirected to the home page in 10 seconds.
        </div>
      )}
    </UserTemplate>
  );
}
